export function OutlineChevronRightIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.37 11.535L14.54 14.365L9.42 19.485C8.64 20.265 7.37 20.265 6.59 19.485C6.2 19.095 6 18.585 6 18.075C6 17.565 6.2 17.045 6.59 16.655L11.71 11.535L6.59 6.415C5.81 5.635 5.81 4.365 6.59 3.585C7.37 2.805 8.64 2.805 9.42 3.585L17.37 11.535Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
